import { AssignStrategy } from "./AssignStrategy";
import { Participant } from "./Participant";

export class ParticipantInfo {
    constructor() {
        this.assignStrategy = new AssignStrategy();
        this.humanPerformerList = new Array();
        this.potentialOwnerList = new Array();
        this.isAllScope = false;
    }
    assignStrategy: AssignStrategy;
    humanPerformerList: Array<Participant>;
    potentialOwnerList: Array<Participant>;
    isAllScope: boolean;
}